import { useMemo } from 'react'
import { NativeSelect, Text, Field } from '@chakra-ui/react';
import type { TagPickerDto } from '../../types/script'

interface TagAssignmentElementFieldsProps {
  tagId: string | null | undefined
  tagOptions: TagPickerDto[]
  onChange: (tagId: string | null) => void
}

export function TagAssignmentElementFields({
  tagId,
  tagOptions,
  onChange,
}: TagAssignmentElementFieldsProps) {
  const assignableTags = useMemo(
    () => tagOptions.filter((t) => t.canBeAssigned),
    [tagOptions]
  )

  return (
    <>
      <Field.Root>
        <Field.Label fontSize="sm">Tag to Assign</Field.Label>
        <NativeSelect.Root size="sm">
          <NativeSelect.Field
            value={tagId ?? ''}
            onChange={(e) => onChange(e.target.value || null)}
            placeholder="Select a tag...">
            {assignableTags.map((tag) => (
              <option key={tag.id} value={tag.id}>
                {tag.label}
                {tag.tagType ? ` (${tag.tagType})` : ''}
              </option>
            ))}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
      </Field.Root>
      {assignableTags.length === 0 && (
        <Text fontSize="sm" color="gray.400" fontStyle="italic">
          No assignable tags available. Create tags in the Tags section first.
        </Text>
      )}
    </>
  );
}
